import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';

const MD = ({ children, options }) => {
  const defaultOverrides = {
    h1: {
      props: {
        className: 'text-3xl',
      },
    },
    h2: {
      props: {
        className: 'text-2xl',
      },
    },
    h3: {
      props: {
        className: 'text-xl',
      },
    },
    h4: {
      props: {
        className: 'text-lg',
      },
    },
    h5: {
      props: {
        className: 'text-base',
      },
    },
    h6: {
      props: {
        className: 'text-sm',
      },
    },
  };

  const mdOptions = {
    ...options,
    overrides: options.overrides
      ? Object.assign(options.overrides, defaultOverrides)
      : defaultOverrides,
  };

  return <Markdown options={mdOptions}>{children}</Markdown>;
};

MD.defaultProps = {
  options: {},
};

MD.propTypes = {
  children: PropTypes.string.isRequired,
  /**
   * For details and usage see `markdown-to-jsx` [documentation](https://www.npmjs.com/package/markdown-to-jsx#parsing-options)
   */
  options: PropTypes.shape({ overrides: PropTypes.shape({}) }),
};

export default MD;
